import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';

type DeleteCommentVariables = {
    orgId: string;
    dealId: number;
    timelineId: number;
    commentId: number;
};

export const deleteComment = async ({
    orgId, dealId, commentId,
}: DeleteCommentVariables): Promise<void> => {
    await axiosInstance.delete(API_ENDPOINTS.COMMENT_BY_ID(orgId, dealId, commentId));
};

export const useDeleteComment = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteComment,
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.TIMELINE_COMMENTS, variables.orgId, variables.dealId, variables.timelineId],
            });
        },
    });
};
